import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var WydrukKlient = React.createClass({

	getInitialState: function() {
		this.getDictListwy();
		return {
			wydrukKlient: {
				id: '',
				cena: '',
				czyZdjecie: '',
				grubosc: '',
				hdf: '',
				kosztUslugi: '',
				lustro: '',
				numerListwy: '',
				numerPass: '',
				operator: '',
				punktSprzedazy: '',
				szerokosc: '',
				szklo: '',
				uwagi: '',
				wysokosc: '',
				zawieszka: '',
				dataZlozenia: '',
				imie: '',
				nazwisko: '',
				telefon: '',
				pozostalaDoplata: '',
				dataOdbioru: '',
				czyPass: '',
				zaliczka: '',
			},
			dictListwa:{
				id: '',
	      numerListwy: '',
	      cenaZaMb: 0.00
			},
			dataDictListwy: null,
			platnosci:{
				kosztListwy: '',
				kosztSzkla: '',
				kosztHdf: '',
				kosztZawieszki: '',
				kosztLustra: '',
				kosztPass: '',
			}
		}
    },

		punktNrTel: function() {
			if (this.state.wydrukKlient.punktSprzedazy === 'Castorama') return (<ControlLabel> 533-972-777</ControlLabel>);
			else if (this.state.wydrukKlient.punktSprzedazy === 'Arena') return (<ControlLabel> 796-927-777</ControlLabel>);
		},

		render: function() {

			return (
				<Modal show={this.props.parent.state.showWydrukKlientModal}>
					<Modal.Header>
						<Modal.Title>Wydruk dla Klienta - Zlecenie nr {this.state.wydrukKlient.id}</Modal.Title>
					</Modal.Header>
					<Modal.Body id = "printable">
					<div>

					<table>
					<tbody>
						<tr>
							<td>Data: </td>
							<td>{this.state.wydrukKlient.dataZlozenia}</td>
							<td>Numer zamówienia: </td>
							<td>{this.state.wydrukKlient.id}</td>
						</tr>
						<tr>
							<td rowSpan="4">Nazwisko: </td>
							<td rowSpan="4">{this.state.wydrukKlient.nazwisko}</td>
							<td>Cena listwy: </td>
							<td>{parseFloat(this.state.platnosci.kosztListwy).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Cena szkła: </td>
							<td>{parseFloat(this.state.platnosci.kosztSzkla).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Cena HDF: </td>
							<td>{parseFloat(this.state.platnosci.kosztHdf).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Cena zawieszki: </td>
							<td>{parseFloat(this.state.platnosci.kosztZawieszki).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td rowSpan="3">Telefon: </td>
							<td rowSpan="3">{this.state.wydrukKlient.telefon}</td>
							<td>Cena lustra: </td>
							<td>{parseFloat(this.state.platnosci.kosztLustra).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Cena passe partout: </td>
							<td>{parseFloat(this.state.platnosci.kosztPass).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Cena usługi: </td>
							<td>{parseFloat(this.state.wydrukKlient.kosztUslugi).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td>Data odbioru: </td>
							<td>{this.state.wydrukKlient.dataOdbioru}</td>
							<td>Wartość zamówienia: </td>
							<td>{parseFloat(this.state.wydrukKlient.cena).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td colSpan="2">Wpłacona zaliczka: </td>
							<td colSpan="2">{parseFloat(this.state.wydrukKlient.zaliczka).toFixed(2)} zł</td>
						</tr>
						<tr>
							<td colSpan="2">Numer listwy: </td>
							<td colSpan="2">{this.state.wydrukKlient.numerListwy}</td>
						</tr>
						<tr>
							<td colSpan="2">Numer passe partout: </td>
							<td colSpan="2">{this.state.wydrukKlient.numerPass}</td>
						</tr>
						<tr>
							<td colSpan="2">Uwagi: </td>
							<td colSpan="2">Podpis: </td>
						</tr>
						<tr>
							<td colSpan="2">{this.state.wydrukKlient.uwagi}</td>
							<td colSpan="2"></td>
						</tr>
						<tr>
							<td colSpan="2">Punkt sprzedaży: {this.state.wydrukKlient.punktSprzedazy}</td>
							<td colSpan="2">Sprzedawca: {this.state.wydrukKlient.operator}</td>
						</tr>
						<tr>
							<td colSpan="2">Telefon: </td>
							<td>{this.punktNrTel()}</td>
							<td>600-803-231</td>
						</tr>
						</tbody>
						</table>

					</div>

					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeWydrukKlientModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onDrukujBtnClicked}>Drukuj</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	fillWydrukKlientObject: function() {
    	var selectedZlecenie = this.props.parent.getZlecenieById(this.props.parent.state.selectedZlecenieId);

		 this.state.wydrukKlient = {
			id: selectedZlecenie.id,
			cena: selectedZlecenie.cena,
			czyZdjecie: selectedZlecenie.czyZdjecie,
			grubosc: selectedZlecenie.grubosc,
			hdf: selectedZlecenie.hdf,
			kosztUslugi: selectedZlecenie.kosztUslugi,
			lustro: selectedZlecenie.lustro,
			numerListwy: selectedZlecenie.numerListwy,
			numerPass: selectedZlecenie.numerPass,
			operator: selectedZlecenie.operator,
			punktSprzedazy: selectedZlecenie.punktSprzedazy,
			szerokosc: selectedZlecenie.szerokosc,
			szklo: selectedZlecenie.szklo,
			uwagi: selectedZlecenie.uwagi,
			wysokosc: selectedZlecenie.wysokosc,
			zawieszka: selectedZlecenie.zawieszka,
			dataZlozenia: selectedZlecenie.dataZlozenia,
			imie: selectedZlecenie.imie,
			nazwisko: selectedZlecenie.nazwisko,
			telefon: selectedZlecenie.telefon,
			pozostalaDoplata: selectedZlecenie.pozostalaDoplata,
			dataOdbioru: selectedZlecenie.dataOdbioru,
			czyPass: selectedZlecenie.czyPass,
			zaliczka: selectedZlecenie.zaliczka,
		}

		this.dictListwa = this.getListwaByNrListwy(this.state.wydrukKlient.numerListwy);

		var dlListwy = (parseFloat(parseFloat(this.state.wydrukKlient.wysokosc * 2) + parseFloat(this.state.wydrukKlient.szerokosc * 2)) + parseFloat(this.state.wydrukKlient.grubosc * 8)) / 100
		var kosztListwy = this.dictListwa ? (dlListwy * (this.dictListwa ? parseFloat(this.dictListwa.cenaZaMb) : 1)) : 0.00

		var pole = parseFloat((this.state.wydrukKlient.wysokosc / 100) * (this.state.wydrukKlient.szerokosc) / 100)
		var kosztSzkla = this.state.wydrukKlient.szklo ? parseFloat(60 * pole) : 0.00

		if ((this.state.wydrukKlient.szklo == 'Wybierz typ') || (this.state.wydrukKlient.szklo == 'NIE')) kosztSzkla = 0.00

		  this.state.platnosci.kosztListwy = (isNaN(kosztListwy) ? 0.00 : kosztListwy);
			this.state.platnosci.kosztSzkla = (isNaN(kosztSzkla) ? 0.00 : kosztSzkla);
			this.state.platnosci.kosztHdf = this.state.wydrukKlient.hdf ? parseFloat(35 * pole): 0.00;
			this.state.platnosci.kosztZawieszki = this.state.wydrukKlient.zawieszka ? parseFloat(2.90) : 0.00;
			this.state.platnosci.kosztLustra = this.state.wydrukKlient.lustro ? parseFloat(160 * pole) : 0.00;
			this.state.platnosci.kosztPass = this.state.wydrukKlient.czyPass ? parseFloat(70 * pole) : 0.00;



	},

	clearWydrukKlientObject: function() {
		this.state.wydrukKlient.id = '';
		this.state.wydrukKlient.imie = '';
		this.state.wydrukKlient.nazwisko = '';
		this.state.wydrukKlient.telefon = '';
		this.state.wydrukKlient.numerListwy = '';
		this.state.wydrukKlient.szerokosc = '';
		this.state.wydrukKlient.wysokosc = '';
		this.state.wydrukKlient.grubosc = '';
		this.state.wydrukKlient.cena = '';
		this.state.wydrukKlient.numerPass = '';
		this.state.wydrukKlient.szklo = '';
		this.state.wydrukKlient.hdf = '';
		this.state.wydrukKlient.kosztUslugi = '';
		this.state.wydrukKlient.lustro = '';
		this.state.wydrukKlient.operator = '';
		this.state.wydrukKlient.uwagi = '';
		this.state.wydrukKlient.punktSprzedazy = '';
		this.state.wydrukKlient.czyZdjecie = '';
		this.state.wydrukKlient.zawieszka = '';
		this.state.wydrukKlient.dataZlozenia = '';
		this.state.wydrukKlient.pozostalaDoplata = '';
		this.state.wydrukKlient.dataOdbioru = '';
		this.state.wydrukKlient.czyPass = '';
		this.state.wydrukKlient.zaliczka = '';
	},

	getDictListwy: function() {
		axios.get('http://217.182.200.222:8080/dictListwy')
		.then(function (dictListwa) {
			this.setState({dataDictListwy: dictListwa.data});
		}.bind(this));
	},

	getListwaByNrListwy: function(numerListwy) {
		for(var i in this.state.dataDictListwy) {
			if(this.state.dataDictListwy[i].numerListwy == numerListwy) {
				return this.state.dataDictListwy[i];
			}
		}
		return 'brak';
	},

	onDrukujBtnClicked: function() {
		this.printDiv('printable');

    this.sleep(3000).then(() => {
        window.location.reload(true);
    });
},

sleep: function(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
},

 printDiv: function(divName){
			var printContents = document.getElementById(divName).innerHTML;
			var originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
			window.print();
		}
});

export default WydrukKlient;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/WydrukKlient.js